import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import {
    Box,
    Stack,
    Button,
    Card,
    CardContent,
    CardHeader,
    Chip,
    Typography,
} from "@mui/material";
import AlertMessage from "../../../Common/Alert/AlertMessage";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";
import DescriptionIcon from "@mui/icons-material/Description";

function ActivityResourceContent({ activity, onClick, onRemove, onUpload }) {
    const [openDialog, setOpenDialog] = useState(null);
    const [selectedResource, setSelectedResource] = useState(null);

    const handleOpenRemoveDialog = (resource) => () => {
        setSelectedResource(resource);
        setOpenDialog("remove");
    };

    const handleCloseDialog = useCallback(() => {
        setOpenDialog(null);
        setSelectedResource(null);
    }, []);

    const resourceCount = activity?.resources?.length || 0;

    let alert = {
        active: false,
        severity: "",
        message: "",
    };

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                title={
                    <Typography component="h2" className="card-header-title">
                        Resources
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {resourceCount > 0
                            ? "The following resources support this activity"
                            : "Attach resources (documents, photos, etc.) to support this activity."}
                    </Typography>
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        {activity.canUpdate && (
                            <>
                                <Button
                                    variant="contained"
                                    color="neutral"
                                    disableElevation={true}
                                    aria-label="Upload a file"
                                    onClick={onUpload}
                                    startIcon={<FileUploadIcon />}
                                >
                                    Upload
                                </Button>
                                <Button
                                    variant="contained"
                                    color="neutral"
                                    disableElevation={true}
                                    aria-label="Attach a resource"
                                    onClick={onClick}
                                    startIcon={<AttachFileIcon />}
                                >
                                    Attach
                                </Button>
                            </>
                        )}
                    </Stack>
                }
            />
            <CardContent>
                <Box className="card-content">
                    {activity?.resources?.length > 0 && (
                        <Box className="card-content">
                            {activity.resources.map((resource) => (
                                <Link
                                    to={`/portfolio/resources/${resource.id}`}
                                    key={resource.id}
                                >
                                    <Chip
                                        icon={
                                            <DescriptionIcon
                                                fontSize={"small"}
                                            />
                                        }
                                        label={resource.title}
                                        className="chip"
                                        variant="outlined"
                                        color="primary"
                                        onDelete={
                                            resource?.canDelete
                                                ? handleOpenRemoveDialog(
                                                      resource
                                                  )
                                                : null
                                        }
                                        clickable
                                    />
                                </Link>
                            ))}
                        </Box>
                    )}
                </Box>
            </CardContent>

            {alert.active && (
                <CardContent>
                    <Box className="card-content">
                        <AlertMessage
                            severity={alert.severity}
                            message={alert.message}
                        />
                    </Box>
                </CardContent>
            )}

            {openDialog === "remove" && !!selectedResource && (
                <ConfirmDialog
                    open={true}
                    title="Remove resource"
                    content={`The following resource will be removed: ${selectedResource.title}`}
                    confirmButtonLabel="Remove"
                    onConfirm={() => onRemove(selectedResource.id)}
                    onCancel={handleCloseDialog}
                    onClose={handleCloseDialog}
                />
            )}
        </Card>
    );
}

export default ActivityResourceContent;
